import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import "./Assets/js/maleavatar/anatomy-settings";
import "./Assets/js/maleavatar/anatomy-config";
import "./Assets/js/maleavatar/anatomy-settings-examples";
import "./Assets/js/maleavatar/interact-script";
import "./Assets/js/maleavatar/settings";
import "./Assets/js/maleavatar/spots-settings";
import "./styles/illustration-style.css";
import "./styles/anatomy-style.css";
import './Translation/i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
